export const rupiah = (n) => {
  const v = Number(n) || 0;
  return "Rp " + new Intl.NumberFormat("id-ID", { maximumFractionDigits: 0 }).format(Math.round(v));
};

export const rupiahShort = (n) => {
  const v = Number(n) || 0;
  const abs = Math.abs(v);
  if (abs >= 1e9) return "Rp " + (v / 1e9).toFixed(1) + "M";
  if (abs >= 1e6) return "Rp " + (v / 1e6).toFixed(1) + "jt";
  if (abs >= 1e3) return "Rp " + (v / 1e3).toFixed(1) + "rb";
  return rupiah(v);
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("id-ID", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const timeAgo = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "baru saja";
  if (diff < 3600) return Math.floor(diff / 60) + " menit lalu";
  if (diff < 86400) return Math.floor(diff / 3600) + " jam lalu";
  return Math.floor(diff / 86400) + " hari lalu";
};

export const DENOMS = [100000, 50000, 20000, 10000, 5000, 2000, 1000, 500, 200, 100];

// koersi nilai input MoneyInput ("" | number) menjadi number aman untuk payload/hitung
export const toNum = (v) => (v === "" || v === null || v === undefined || isNaN(Number(v)) ? 0 : Number(v));

// ---- WIB (Asia/Jakarta, UTC+7) helpers ----
export const formatWIB = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      timeZone: "Asia/Jakarta",
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    }) + " WIB";
  } catch {
    return iso;
  }
};

// nilai untuk <input type="datetime-local"> berisi waktu WIB saat ini
export const wibNowLocal = () => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(new Date());
  const m = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return `${m.year}-${m.month}-${m.day}T${m.hour}:${m.minute}`;
};

// konversi nilai datetime-local (dianggap WIB) menjadi ISO UTC untuk disimpan
export const wibLocalToUTCISO = (local) => {
  if (!local) return undefined;
  try {
    return new Date(`${local}:00+07:00`).toISOString();
  } catch {
    return undefined;
  }
};
